export const FIELD_LABELS = {
  price: "판매가",
  consignment_price: "위탁가",
  purchase_price: "매입가",
  benefit_price: "혜택가",
  branch: "지점",
  branches: "지점",
  as_status: "수리상태",
  repair_cost: "수리비용",
  product_remark: "상품 비고",
  bank_name: "은행",
  bank_account: "계좌번호",
  bank_user: "예금주",
};

export const STATUS_LABELS = {
  pending: "대기중",
  approved: "승인",
  rejected: "거절",
  canceled: "철회",
};

export const TYPE_LABELS = {
  product_price: "가격 변경",
  product_account: "입금계좌 변경",
  branch_change: "지점 변경",
  repair_complete: "수리 완료",
  appraisal_review: "감정 검수",
  consultation_registration: "상담일지 등록요청",
  product_bump: "끌어올리기",
  consignment_return: "위탁 반환",
};

// 거래구분(consultation_products.status) 라벨 — 상담일지 등록요청 표시용
export const CONSULT_STATUS_LABELS = {
  1: "매입완료",
  2: "위탁완료",
  3: "매입실패",
  4: "이중검수",
  5: "가품",
  6: "AS외부",
  7: "거래불가",
};

// 고객유형(consultation_summary.customer_type) 라벨 — 매니저어드민 상담일지 고객유형과 동일 3분기.
// 분기 도입 전 구요청은 customer_type 이 없음(전량 신규 정보입력 방식) → 신규로 표기.
export const CUSTOMER_TYPE_LABELS = {
  new: "신규",
  existing: "기존고객",
  unable: "확인불가",
};

// 콤마 포맷 대상이 아닌 텍스트 필드 (특히 계좌번호 — 숫자지만 천단위 콤마 금지)
export const RAW_TEXT_FIELDS = ["bank_name", "bank_account", "bank_user"];

export const APP_LABELS = {
  malladmin: "몰어드민",
  manageradmin: "매니저어드민",
};

export function fieldLabel(key) {
  return FIELD_LABELS[key] || key;
}

export function appLabel(app) {
  return app ? APP_LABELS[app] || app : "";
}

export function dot(value) {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "number") return value.toLocaleString();
  if (/^-?\d+(\.\d+)?$/.test(String(value))) {
    return Number(value).toLocaleString();
  }
  return String(value);
}

/**
 * before/after 값 표시.
 * branches 신포맷(정수 ID 배열)은 branchesResolved (id → {id,name}) 가 있으면 이름으로 변환.
 */
export function formatValue(field, value, branchesResolved) {
  if (field === "branch") return value || "-";
  // 입금계좌 필드는 원문 그대로 (계좌번호 콤마 방지)
  if (RAW_TEXT_FIELDS.includes(field)) {
    return value === null || value === undefined || value === "" ? "-" : String(value);
  }
  if (field === "branches") {
    if (!Array.isArray(value) || value.length === 0) return "-";
    if (!branchesResolved) return value.join(", ");
    return value
      .map((id) => branchesResolved[id]?.name || `#${id}`)
      .join(", ");
  }
  return dot(value);
}

export function fromInputDigits(text) {
  return String(text || "").replace(/[^0-9]/g, "");
}

export function relativeTime(iso) {
  if (!iso) return "";
  const date = new Date(String(iso).replace(/-/g, "/"));
  if (Number.isNaN(date.getTime())) return iso;
  const diff = Math.floor((Date.now() - date.getTime()) / 1000);
  if (diff < 60) return "방금 전";
  if (diff < 3600) return `${Math.floor(diff / 60)}분 전`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}시간 전`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}일 전`;
  return iso.slice(0, 16);
}
